import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminProvider } from '../../contexts/AdminContext';
import AdminLogin from './AdminLogin';
import AdminLayout from './AdminLayout';
import AdminDashboard from './AdminDashboard';
import MenuCategories from './MenuCategories';
import MenuItems from './MenuItems';
import AdminUsers from './Users/AdminUsers';
import RestaurantInfo from './RestaurantInfo';
import PagePhotos from './PagePhotos';
import PagePhotosTest from './PagePhotosTest';
import PageBuilder from '../PageBuilder/PageBuilder';
import PermissionGuard, { AdminOnly, EditorAndUp } from './PermissionGuard';
import TestLogin from '../Debug/TestLogin';
import TestFallback from '../Debug/TestFallback';


function AdminRoutes() {
  return (
    <AdminProvider>
      <Routes>
        {/* Login Route */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/test" element={<TestLogin />} />
        <Route path="/admin/test-fallback" element={<TestFallback />} />
        
        {/* Protected Admin Routes */}
        <Route path="/admin/dashboard" element={
          <AdminLayout>
            <AdminDashboard />
          </AdminLayout>
        } />
        
        <Route path="/admin/categories" element={
          <AdminLayout>
            <EditorAndUp>
              <MenuCategories />
            </EditorAndUp>
          </AdminLayout>
        } />
        
        <Route path="/admin/menu-items" element={
          <AdminLayout>
            <EditorAndUp>
              <MenuItems />
            </EditorAndUp>
          </AdminLayout>
        } />
        
        <Route path="/admin/restaurant-info" element={
          <AdminLayout>
            <EditorAndUp>
              <RestaurantInfo />
            </EditorAndUp>
          </AdminLayout>
        } />
        
        <Route path="/admin/page-photos" element={
          <AdminLayout>
            <EditorAndUp>
              <PagePhotos />
            </EditorAndUp>
          </AdminLayout>
        } />
        
        <Route path="/admin/page-builder" element={
          <AdminLayout>
            <EditorAndUp>
              <PageBuilder />
            </EditorAndUp>
          </AdminLayout>
        } />
        
        <Route path="/admin/users" element={
          <AdminLayout>
            <AdminOnly>
              <AdminUsers />
            </AdminOnly>
          </AdminLayout>
        } />
        
        {/* Default redirect */}
        <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
        
        {/* Catch-all redirect for unmatched admin routes */}
        <Route path="/admin/*" element={<Navigate to="/admin/dashboard" replace />} />
      </Routes>
    </AdminProvider>
  );
}

export default AdminRoutes;